module.exports = __webpack_public_path__ + "static/media/MainLogo.1ecb2234.png";